import React, { Component } from 'react'
//import { Link } from 'react-router-dom'
import '../styles/GlobalStyle.css'
import { db, firebase } from '../firebase/Firebase'
import { getQueryStringParam, flattenDoc, linkAfterLogin, DEV_CLEVER_CLIENT_ID, DEV_CLEVER_REDIRECT_URI } from '.././Util'
import ColType from '.././Types'
import { message, Spin } from 'antd'
import CustomFooter from './CustomFooter'

/*
const successMessage = (description) => {
    message.success(description)
}
*/

const errorMessage = (description) => {
    message.error(description)
}

class SignInClever extends Component {
    state = {
        cleverCode: '',
        userRole: '',
        user: null,
        signingIn: false,
        hideEmail: false,
        cleverCodeError: false,
        userNotFoundError: false,
        userArchivedError: false,
    }

    componentDidMount() {
        document.title = "Sign in with Clever - Dot It"
        let cleverCode = getQueryStringParam('code')

        this.setState({
            cleverCode: cleverCode,
        }, () => {
            this.handleCleverSignIn()
        })
    }

    handleCleverSignIn = async () => {
        if (!this.state.cleverCode) {
            return
        }

        const cleverCode = this.state.cleverCode

        let headers = new Headers()
        headers.append('Origin', 'https://my.dotit.app')
        headers.append('Content-Type', 'application/json')
        headers.append('Access-Control-Allow-Origin', 'https://my.dotit.app')

        fetch("https://us-central1-education-9d7f3.cloudfunctions.net/app/dotit/clever-sign-in", {
            method: "POST",
            body: JSON.stringify({
                cleverCode: cleverCode,
            }),
            mode: 'cors',
            headers: headers,
        })
            .then(res => res.json())
            .then(data => {
                //console.log('data', data)

                if (data.hasOwnProperty('message') &&
                    data.message === 'Error during Clever OAuth process') {
                    this.setState({
                        cleverCodeError: true,
                    })
                } else if (data.hasOwnProperty('message') &&
                    data.message === 'Error account not found') {
                    this.setState({
                        userNotFoundError: true,
                    })
                } else if (data.hasOwnProperty('message') &&
                    data.message === 'Error account archived') {
                    this.setState({
                        userArchivedError: true,
                    })
                } else {
                    firebase.auth().signInWithCustomToken(data.token)
                        .then((userObj) => {
                            const user = userObj.user
                            //console.log('user sign in', user)
                            db.collection(ColType.users)
                                .doc(user.uid)
                                .get()
                                .then((doc) => {
                                    var userInfo = flattenDoc(doc)
                                    if (userInfo.accessLevel === 'superAdmin') {
                                        window.location.href = '/super-admin/add-initial-admin'
                                        return
                                    }
                                    else {
                                        db.collection(userInfo.accessLevel)
                                            .doc(userInfo.refId)
                                            .get()
                                            .then((doc) => {
                                                var userJobInfo = flattenDoc(doc)
                                                linkAfterLogin(userInfo, userJobInfo)
                                            })
                                    }
                                }).catch((error) => {
                                    //console.log('get user info error', error)
                                    this.setState({
                                        submitting: false,
                                    })
                                })
                        })
                        .catch((error) => {
                            //console.log('user sign in error', error)
                        })
                }
            })
            .catch(e => {
                //console.log("request error", e)
                errorMessage('An error occurred, please try again.')
                this.setState({
                    submitting: false,
                })
            })
    }

    render() {
        return (
            <div className="pt-4 pb-70 relative" style={{ minHeight: '100%' }}>
                <div className='absolute-tl w-100 h-100'>
                </div>

                <div className='relative'>
                    <div className="text-center mb-4 mt-2">
                        <img src='/dotit-logo-color-new.png' alt='logo' height='70' />
                    </div>
                    <div className="p-4 w-500 m-lr-auto br-20 ant-shadow background-fff">
                        <div className="block w-100 m-lr-auto mb-1 text-center">
                            <img src="/dot-it-sign-in.png" alt="sign-in" height="300" />
                        </div>
                        {!this.state.cleverCodeError && !this.state.userNotFoundError && !this.state.userArchivedError ?
                            <div className='text-center'>
                                <div className="mb-3 text-center pt-3 font-30 font-bold">Welcome to Dot It</div>
                                <Spin size="large" className="ant-spin-vlg" />
                            </div>
                            : ''}
                        {this.state.cleverCodeError ?
                            <div className='text-center'>
                                <div className="mb-1 text-center pt-3 font-30 font-bold">Welcome to Dot It</div>
                                <div className='pl-1 pr-1'>
                                    <div className='text-left font-20 p-3 br-4 bg-light-red mb-2'>
                                        Oops, something went wrong. Please try logging in again.
                                    </div>
                                </div>
                                <a href={`https://clever.com/oauth/authorize?response_type=code&client_id=${DEV_CLEVER_CLIENT_ID}&redirect_uri=${DEV_CLEVER_REDIRECT_URI}`}>
                                    <img src="https://files.readme.io/efb3f5d-LogInWithClever2x.png" alt="Clever log in button" class="" align="" caption="" height="auto" width="auto" loading="lazy" />
                                </a>
                            </div> : ''}
                        {this.state.userNotFoundError ?
                            <div className='text-center'>
                                <div className="mb-1 text-center pt-3 font-30 font-bold">Welcome to Dot It</div>
                                <div className='pl-1 pr-1'>
                                    <div className='text-left font-20 p-3 br-4 bg-light-red mb-2'>
                                        Your account was not found.
                                    </div>
                                </div>
                            </div> : ''}
                        {this.state.userArchivedError ?
                            <div className='text-center'>
                                <div className="mb-1 text-center pt-3 font-30 font-bold">Welcome to Dot It</div>
                                <div className='pl-1 pr-1'>
                                    <div className='text-left font-20 p-3 br-4 bg-light-red mb-2'>
                                        Your account has been archived.
                                    </div>
                                </div>
                            </div> : ''}
                    </div>
                    <CustomFooter
                        theme='dark'
                    />

                </div>
            </div>
        )
    }
}

export default SignInClever